module.exports = __webpack_public_path__ + "img/dpd_logo.1feb8460.png";